<template>
  <div class="quickScore">
      <b-row>
        <b-col lg="5" md="12">
          <b-row class="ShowMobile">
            <b-col>
              <b-img class="tournHeadLogoMob" :src="tmparams.sponsor_logo"></b-img>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <h3 class="tournHead">
                {{ tmparams.full_name }}
              </h3>
              <h3 class="tournDates">
                {{ tmparams.dates }}
              </h3>
              <h3 class="tournDates">
                {{ tmparams.course_name }}
              </h3> 
            </b-col>
          </b-row>
          <b-row style="padding-top:20px;" class="paddBottom">
            <b-col>
              <template v-if="tmparams.winner_found === 'Y'">
                <h3 class="reportInfo" :style="TextColor">
                  {{ tmparams.winner_name }}
                </h3>
                <h3 class="tournDates">
                  Champion
                </h3>
              </template>
              <template v-if="tmparams.winner_found === 'N'">
                <h3 class="reportInfo" :style="TextColor" v-if="tmparams.previous_winners.previous_winners_entry.cc_name_1">
                  {{
                    tmparams.previous_winners.previous_winners_entry.cc_name_1
                  }}
                </h3>
                <h3 class="reportInfo" :style="TextColor" v-else>
                    N/A
                </h3>
                <h3 class="tournDates">
                  Defending Champion
                </h3>
              </template>
            </b-col>
            <b-col>
              <h3 class="reportInfo" :style="TextColor">
                {{ tmparams.total_prize_fund }}
              </h3>
              <h3 class="tournDates ">
                Purse
              </h3>
            </b-col>
          </b-row>
          <!-- <b-row v-if="multi_tourns == 'Y'" class="dropDownArea">  
            <b-col>
                <b-form-select v-model="code" class="TourndropdownArea" @change="swapTour(code)"> 
                  <b-form-select-option 
                    class="opt-arrow"
                    v-for="(past,
                    index) in listFinalAll"
                    :key="index" 
                    :value="past.code"
                  >
                    {{ past.name }}
                  </b-form-select-option>
                </b-form-select>
            </b-col>
          </b-row> -->
          <b-row
            class="tabRow"
            v-if="
              title === 'Scores Round ' + this.data.pft_round &&
                this.data.match_play === 'N'
            "
          >
            <b-col class="NoPad NopadLeft">
              <b-button
                class="tabBtn"
                :class="{ active: isHidden === '1' }"
                v-on:click="isHidden = '1'"
              >
                Leaderboard
              </b-button>
            </b-col>
            <b-col v-if="teamEvent === 'Y'" class="NoPad">
              <b-button
                class="tabBtn"
                :class="{ active: isHidden === '3' }"
                v-on:click="isHidden = '3'"
              >
                Team
              </b-button>
            </b-col>
            <b-col class="NoPad">
              <b-button
                class="tabBtn"
                :class="{ active: isHidden === '2' }"
                v-on:click="isHidden = '2'"
              >
                Hole-by-Hole
              </b-button>
            </b-col>
          </b-row>
        </b-col>
        <b-col>
          <b-row>
            <b-col>
              <b-img class="tournHeadLogo" :src="tmparams.sponsor_logo"></b-img>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <template v-if="isMobile(true)">
                <iframe class="imob" :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + Year + '&name=' + tmparams.course_city + '&timediff=' + tmparams.time_diff_dec + '&code=' + code + '&until=' + tmparams.days_away + '&tour=aus'" style="width:100%;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
              </template>
              <template v-else>
                <iframe :src="'https://wp-ocssport.ocs-sport.com/aus-js/html/golf_aus_pga_HTML_300x75/rolex.html?id=' + Year + '&name=' + tmparams.course_city + '&timediff=' + tmparams.time_diff_dec + '&code=' + code + '&until=' + tmparams.days_away + '&tour=aus'" style="width:300px;height:75px;border:0;margin:0;padding:0;overflow:hidden;scroll:none" SCROLLING=NO frameborder="NO"></iframe>
              </template>
            </b-col>
          </b-row>
        </b-col>
        <b-col class="hidebelow1200">
          <div class="ad" style="float: right;">
            <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
            <script type="application/javascript">
              window.googletag = window.googletag || {cmd: []};
              googletag.cmd.push(function() {
              billboardsizes = googletag.sizeMapping()
              .addSize([0,0],[300,250])
              .build();
              googletag.defineSlot('/27436116/Golf_PGA_MRec', [[300, 250]], 'mrec').defineSizeMapping(billboardsizes).addService(googletag.pubads());
              googletag.pubads().enableSingleRequest();
              googletag.enableServices();
              });
            </script>

            <div id='mrec' class="lazy" style="text-align:center; margin:auto">
              <div v-bind:style="{ 'background-image': 'url(' + 'https://tpc.googlesyndication.com/simgad/4344768451824435984' + ')' }" style="text-align:center; margin:auto; background-repeat: no-repeat; height: 250px; margin: auto; background-position: center;">
                <script type="application/javascript">
                  googletag.cmd.push(function() { googletag.display('mrec'); });
                </script>
              </div>
            </div>
          </div>

        <!-- Please ignore the ad code below if removed it breaks ad above -->
        <div class="ad" style="display:none">
            <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js" type="application/javascript"></script>
            <script type="application/javascript">
              window.googletag = window.googletag || {cmd: []};
              googletag.cmd.push(function() {
              billboardsizes = googletag.sizeMapping()
              .addSize([0,0],[300,250])
              .build();
              googletag.defineSlot('/27436116/Golf_PGA_MRec', [[300, 250]], 'mrec').defineSizeMapping(billboardsizes).addService(googletag.pubads());
              googletag.pubads().enableSingleRequest();
              googletag.enableServices();
              });
            </script>

            <div id='mrec' class="lazy" style="text-align:center; margin:auto">
              <div v-bind:style="{ 'background-image': 'url(' + 'https://tpc.googlesyndication.com/simgad/4344768451824435984' + ')' }" style="text-align:center; margin:auto; background-repeat: no-repeat; height: 250px; margin: auto; background-position: center;">
                <script type="application/javascript">
                  googletag.cmd.push(function() { googletag.display('mrec'); });
                </script>
              </div>
            </div>
        </div>
        <!-- Please ignore the ad code above if removed it breaks ad above -->
        </b-col>  
      </b-row>
      <b-row class="topPad">
        <b-col lg="6" md="6" cols="12" :class="{colWidth: tmparams.multi_course === 'Y'}">
          <div :class="drop">
            <b-nav card-header pills>
              <b-dropdown
                v-if="Array.isArray(tmparams.reports.reports_entry)"
                :text="title.replace('(Pro)', '').replace('(Team)', '')"
              >
                <b-dropdown-item
                  v-on:click="changeReport"
                  v-for="(reports, index) in filterExemptions"
                  :key="index"
                  :title="reports.report_url"
                  :value="reports.report_title"
                  v-show="!reports.report_title.includes('(Team)')"
                  >{{ reports.report_title.replace("(Pro)", "").replace('(Team)', '') }}</b-dropdown-item
                >
              </b-dropdown>
              <b-dropdown v-else text="Tournament Entries">
                <b-dropdown-item
                  v-on:click="changeReport"
                  v-for="(reports, index) in tmparams.reports"
                  :key="index"
                  :title="reports.report_url"
                  v-show="reports.report_title !== 'Scoring Statistics' && reports.report_title !== 'Course Statistics' && reports.report_title !== 'Course Statistics (COR)' && reports.report_title !== 'Course Statistics (REM)' && reports.report_title !== 'Statistics Tables'"
                  >{{ reports.report_title }}</b-dropdown-item
                >
              </b-dropdown>
            </b-nav>
          </div>
        </b-col>
        <b-col lg="6" md="6" cols="12">
          <div class="sponLogo">
            <img class="informationImg" v-b-toggle="'collapse-1'" src="https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/Icon-ion-md-information-circle.png">
          </div>
          <template v-if="data.live_scoring == 'Y' && tmparams.days_away == '0'">
            <template v-if="isMobile(true)">
              <b-button v-if="basketAddSuccess == false" class="playerInfoButtonMob" @click="getData();">
              </b-button>
              <b-button v-if="basketAddSuccess == true" class="playerInfoButtonTrue">
              </b-button>
            </template>
            <template v-else>
              <b-button  v-if="basketAddSuccess == false" class="playerInfoButton" @click="getData();">
              </b-button>
              <b-button  v-if="basketAddSuccess == true" class="playerInfoButtonTrue">
              </b-button>
            </template>
          </template>
        </b-col>
      </b-row>

    <template v-if="tmparams.show_info_web == 'Y'">
      <b-collapse id="collapse-1" class="mt-2 informationCLass" visible>
        <Information
              :data="this.data"
              :home="home"
              :previousData="previousData"
              :title="title"
              :season="tmparams.tm_params.season_code"
              :code="tmparams.code"
              :tour="this.$route.query.tour"
              :team="'N'"
              :config="config"
              :match="tmparams.match_play"
              :showGender="tmparams.show_gender"
              :currentReport="currentReport"
              :hasAmaPlayers="hasAmaPlayers"
              :hasSponsPlayer="hasSponsPlayer"
              :hasEntSponsPlayer="hasEntSponsPlayer"
              :hasNonFirstTee="hasNonFirstTee"
        />
      </b-collapse>
    </template>
    <template v-else>
      <b-collapse id="collapse-1" class="mt-2 informationCLass">
        <Information
              :data="this.data"
              :home="home"
              :previousData="previousData"
              :title="title"
              :season="tmparams.tm_params.season_code"
              :code="tmparams.code"
              :tour="this.$route.query.tour"
              :team="'N'"
              :config="config"
              :match="tmparams.match_play"
              :showGender="tmparams.show_gender"
              :currentReport="currentReport"
              :hasAmaPlayers="hasAmaPlayers"
              :hasSponsPlayer="hasSponsPlayer"
              :hasEntSponsPlayer="hasEntSponsPlayer"
              :hasNonFirstTee="hasNonFirstTee"
        />
      </b-collapse>
    </template>
    <!-- :rts="data.rts[0]" -->

      <div v-if="Object.keys(data).length === 0">
        <b-row>
          <b-col>
              <div class="loader"></div>
          </b-col>
        </b-row>
      </div>
      <!-- Changed the below from currentReport  to fullURL otherwise it wont work -->
      <div v-else class="reports">
          <div
            v-if="
              this.currentReport.indexOf('entr') !== -1 ||
                this.currentReport.indexOf('draw') !== -1 ||
                this.currentReport.indexOf('resu') !== -1 ||
                this.currentReport.indexOf('result-result') !== -1 ||
                this.currentReport.indexOf('tmtsum') !== -1 ||
                this.currentReport.indexOf('tmoomt') !== -1 
            "
          >
            <ReportTable
              :data="this.data"
              :home="home"
              :previousData="previousData"
              :title="title"
              :season="tmparams.tm_params.season_code"
              :code="tmparams.code"
              :tour="this.$route.query.tour"
              :team="'N'"
              :config="config"
              :match="tmparams.match_play"
              :showGender="tmparams.show_gender"
            />
          </div>
          <div
            class="main"
            v-else-if="this.currentReport.indexOf('scores') !== -1"
          >
            <template v-if="data.match_play == 'N' && data.team_scoreboard_only == 'N'">
              <b-tabs content-class="mt-3">
                <b-tab
                  title="Leaderboard"
                  active
                  title-item-class="hideLeadertab"
                >
                  <ReportTable
                    :data="data"
                    :title="title"
                    :home="false"
                    :updown="updown"
                    :config="config"
                    :team="teamEvent"
                    :match="match"
                    :showGender="tmparams.show_gender"
                    :tour="this.$route.query.tour"
                  />
                </b-tab>
                <b-tab title="Team" v-if="teamEvent === 'Y'">
                  <ReportTable
                    :data="data"
                    :home="home"
                    :season="tmparams.tm_params.season_code"
                    :code="tmparams.code"
                    :tour="this.$route.query.tour"
                    :team="teamEvent"
                    :title="title"
                    :updown="updown"
                    :config="config"
                    :match="match"
                    :showGender="tmparams.show_gender"
                  />
                </b-tab>
                <template v-if="teamEvent === 'Y'">
                  <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH'" >
                    <HBH
                      :data="data"
                      :scores="data.team_scores.team_scores_entry"
                      :previousData="previousData"
                      :config="config"
                    />
                  </b-tab>
                </template>
                <template v-else>
                  <template v-if="data.hole_by_hole != 'N'">
                    <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH'" >
                      <HBH
                        :data="data"
                        :scores="data.scores.scores_entry"
                        :previousData="previousData"
                        :config="config"
                        :showGender="tmparams.show_gender"
                      />
                    </b-tab>
                  </template>
                </template>
              </b-tabs>
            </template>
            <template v-else-if="data.team_scoreboard_only == 'Y'">
              <b-tabs content-class="mt-3">
                <b-tab
                  title="Leaderboard"
                  active
                  title-item-class="hideLeadertab"
                >
                  <ReportTable
                    :data="data"
                    :home="home"
                    :season="tmparams.tm_params.season_code"
                    :code="tmparams.code"
                    :tour="this.$route.query.tour"
                    :team="teamEvent"
                    :title="title"
                    :updown="updown"
                    :config="config"
                    :match="match"
                    :showGender="tmparams.show_gender"
                  />
                </b-tab>
                <template v-if="teamEvent === 'Y'">
                  <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH'" >
                    <HBH
                      :data="data"
                      :scores="data.team_scores.team_scores_entry"
                      :previousData="previousData"
                      :config="config"
                      :showGender="tmparams.show_gender"
                    />
                  </b-tab>
                </template>
                <template v-else>
                  <template v-if="data.hole_by_hole != 'N'">
                    <b-tab title="Hole-by-Hole" :title-item-class="'hideHBH'">
                      <HBH
                        :data="data"
                        :scores="data.scores.scores_entry"
                        :previousData="previousData"
                        :config="config"
                        :showGender="tmparams.show_gender"
                      />
                    </b-tab>
                  </template>
                </template>
              </b-tabs>
            </template>
            <template v-else>
              <ReportTable
                :data="data"
                :home="home"
                :season="tmparams.tm_params.season_code"
                :code="tmparams.code"
                :tour="this.$route.query.tour"
                :team="'N'"
                :title="title"
                :updown="updown"
                :config="config"
                :match="'Y'"
                :showGender="tmparams.show_gender"
              />
            </template>
          </div>
      </div>





      <!-- <div v-if="Object.keys(data).length === 0">
        <b-row>
          <b-col>
            <h2 class="noData">
              No Data....
            </h2>
          </b-col>
        </b-row>
      </div>
      <div v-else class="reports">
          <div
            v-if="
              this.currentReport.includes('tmentry') !== -1 ||
                this.currentReport.includes('tmdraw') !== -1 ||
                this.currentReport.includes('tmresult') !== -1 ||
                this.currentReport.includes('tmtsum') !== -1 ||
                this.currentReport.includes('tmoomt') !== -1
            "
          >
          <b-tabs content-class="mt-3">
            <b-tab
              title="Leaderboard"
              active
              title-item-class="hideLeadertab"
            >
                <ReportTable
                  :data="data"
                  :title="title"
                  :home="false"
                  :updown="updown"
                  :config="config"
                  :team="teamEvent"
                  :match="match"
                />
            </b-tab>
            <b-tab title="Hole-by-Hole" title-item-class="hideHBH">
              <HBH
                :data="data"
                :scores="data.scores.scores_entry"
                :previousData="previousData"
                :config="config"
              />
            </b-tab>
          </b-tabs>
          </div>
          <div
            class="main"
            v-else-if="this.currentReport.includes('tmscores') !== -1"
          >
            <template v-if="match == 'N'">
              <b-tabs content-class="mt-3">
                <b-tab
                  title="Leaderboard"
                  active
                  title-item-class="hideLeadertab"
                >
                  <ReportTable
                    :data="data"
                    :home="home"
                    :season="tmparams.tm_params.season_code"
                    :code="tmparams.code"
                    :tour="this.$route.query.tour"
                    :team="'N'"
                    :title="title"
                    :updown="updown"
                    :config="config"
                    :match="match"
                  />
                </b-tab>
                <b-tab title="Team" v-if="teamEvent === 'Y'">
                  <ReportTable
                    :data="data"
                    :home="home"
                    :season="tmparams.tm_params.season_code"
                    :code="tmparams.code"
                    :tour="this.$route.query.tour"
                    :team="teamEvent"
                    :title="title"
                    :updown="updown"
                    :config="config"
                    :match="match"
                  />
                </b-tab>
                <b-tab title="Hole-by-Hole" title-item-class="hideHBH">
                  <HBH
                    :data="data"
                    :scores="data.scores.scores_entry"
                    :previousData="previousData"
                    :config="config"
                  />
                </b-tab>
              </b-tabs>
            </template>
            <template v-else>
              <ReportTable
                :data="data"
                :home="home"
                :season="tmparams.tm_params.season_code"
                :code="tmparams.code"
                :tour="this.$route.query.tour"
                :team="'N'"
                :title="title"
                :updown="updown"
                :config="config"
                :match="'Y'"
              />
            </template>
          </div>
      </div> -->

      <!-- <b-tabs content-class="mt-3">
        <b-tab
          title="Leaderboard"
          active
          title-item-class="hideLeadertab"
        >
          <ReportTable
          :data="data"
          :title="title"
          :home="false"
          :updown="updown"
          :config="config"
          :team="teamEvent"
          :match="match"
          />
        </b-tab>
        <b-tab title="Team" v-if="teamEvent === 'Y'">
          <ReportTable
            :data="data"
            :title="title"
            :home="false"
            :updown="updown"
            :config="config"
            :team="teamEvent"
            :match="match"
          />
        </b-tab>
        <b-tab title="Hole-by-Hole" title-item-class="hideHBH">
          <HBH
            :data="data"
            :scores="data.scores.scores_entry"
            :previousData="previousData"
            :config="config"
          />
        </b-tab>
      </b-tabs> -->
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
import ReportTable from "@/components/reportTable.vue";
import HBH from "@/ocs/hbh.vue";
import axios from 'axios';
import Information from "@/components/information.vue";
export default {
  name: "Reports Full",
  components: {
    ReportTable,
    HBH,
    Information
  },
  props: ["Year", "codeCourse", "code", "currentReport", "reportURL", "config" , "course_code", "title","tournDates", "updateSize", "widgetHeight", "reports", "tmparams",  "match", "listFinalAll", "multi_tourns", "tour", "dataerror", "id"],

  data() {
    return {
      updown: false,
      fields: [
        { isActive: true, key: "serial_no", label: "No." },
        { isActive: true, key: "playing_name", label: "Player Name" },
        { isActive: true, key: "", label: "Nat." },
        { isActive: true, key: "status_text", label: "Entry Status" },
        { isActive: true, key: "player_profile", label: "" },
      ],
      tableRow: "tableRow",
      data: [],
      tab: "tab",
      cell: "cell",
      home: true,
      MobWidget: process.env.VUE_APP_MOB_WIDGET,
      update: '',
      updateTwo: '',
      updateThree: '',
      basketAddSuccess: ''
      // tour:process.env.VUE_APP_TOUR
    };
  },
  computed: {
    liveOn: function(message) {
      if (this.data.live_scoring === "Y") message = " - Livescoring is on";
      else message = " - " + this.data.round_head;
      return message;
    },
    teamEvent: function(team) {
      var array = this.data;
      if (array["team_scores"] !== undefined) team = "Y";
      else team = "N";
      return team;
    },
    filterExemptions: function() {
      return this.tmparams.reports.reports_entry.filter(
        reports_entry =>
          !reports_entry.report_title.indexOf("Tournament Entries") ||
          !reports_entry.report_title.indexOf("Draw") ||
          !reports_entry.report_title.indexOf("Round 1 Draw") ||
          !reports_entry.report_title.indexOf("Round 2 Draw") ||
          !reports_entry.report_title.indexOf("Round 3 Draw") ||
          !reports_entry.report_title.indexOf("Round 4 Draw") ||
          !reports_entry.report_title.indexOf("Round 5 Draw") ||
          !reports_entry.report_title.indexOf("Round 6 Draw") ||
          !reports_entry.report_title.indexOf("Round 1 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 2 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 3 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 4 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 5 Scores Only") ||
          !reports_entry.report_title.indexOf("Round 6 Scores Only") ||
          !reports_entry.report_title.indexOf("Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 2 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 3 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 4 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 5 Scoreboard") ||
          !reports_entry.report_title.indexOf("Round 6 Scoreboard") ||
          !reports_entry.report_title.indexOf("Final Result")
        // !reports_entry.report_title.indexOf("Live Scoring Monitor")
      );
    },
    reportTitle: function(url) {
      if (this.currentReport.indexOf("tmentry") !== -1) {
        url =
          process.env.VUE_APP_TIC_BASE +
          this.tour +
          "/" +
          this.id +
          "/" +
          this.id +
          "-" +
          this.code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.currentReport.indexOf("tmscores") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
             process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmlsmon") !== -1) {
          {
            url =
              process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.currentReport.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.currentReport.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          console.log("resNum === ");
          console.log(resNum1);
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
    reportTitleUP: function(url) {
      if (this.reportURL.indexOf("tmentry") !== -1) {
        url =
          process.env.VUE_APP_TIC_BASE +
          this.tour +
          "/" +
          this.id +
          "/" +
          this.id +
          "-" +
          this.code +
          "-entry-entries.json?randomadd=" +
          new Date().getTime();
      } else {
        if (this.reportURL.indexOf("tmscores") !== -1) {
          var subRep2 = this.currentReport.lastIndexOf("params=") + 7;
          var indNext2 = this.currentReport.indexOf("~", subRep2);
          var repParams = this.currentReport.substr(
            subRep2,
            indNext2 - subRep2
          );

          if (repParams && repParams.indexOf(".cgi") < 0) {
            url =
             process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-" +
              repParams +
              ".json" +
              "?randomadd=" +
              new Date().getTime();
          } else {
            url =
              process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.reportURL.indexOf("tmlsmon") !== -1) {
          {
            url =
              process.env.VUE_APP_TIC_BASE +
              this.tour +
              "/" +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-scores-latest.json" +
              "?gt=y&randomadd=" +
              new Date().getTime();
          }
        } else if (this.reportURL.indexOf("tmdraw") !== -1) {
          var subRep = this.currentReport.lastIndexOf("round=") + 6;
          var indNext = this.currentReport.indexOf("~", subRep);
          var drawRnd = this.currentReport.substr(subRep, indNext - subRep);
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-draw-R" +
            drawRnd +
            "-draw.json" +
            "?randomadd=" +
            new Date().getTime();
        } else if (this.reportURL.indexOf("tmresult") !== -1) {
          var subRep1 = this.currentReport.lastIndexOf("result=") + 7;
          var indNext1 = this.currentReport.indexOf("~", subRep1);
          var resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          if (resNum1 == '') {
            resNum1 = 'PF'
          } else {
            resNum1 = this.currentReport.substr(subRep1, indNext1 - subRep1);
          }
          console.log("resNum === ");
          console.log(resNum1);
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-result-result-" +
            resNum1 +
            ".json" +
            "?randomadd=" +
            new Date().getTime();
        } else {
          url =
            process.env.VUE_APP_TIC_BASE +
            this.tour +
            "/" +
            this.id +
            "/" +
            this.id +
            "-" +
            this.code +
            "-result-result-PF.json" +
            "?randomadd=" +
            new Date().getTime();
        }
      }
      return url;
    },
    // title: function(title) {
    //   if (this.currentReport.includes("entry")) title = "Tournament Entries";
    //   else if (this.currentReport.includes("draw")) title = "Draw";
    //   else if (this.currentReport.includes("latest")) title = "Live";
    //   else if (this.currentReport.includes("score")) title = "Scores";
    //   else if (this.currentReport.includes("result")) title = "Final Result";

    //   return title;
    // },
  },
  methods: {
    getData: function() {
      console.log('getData')
      this.updateStuff();
      this.basketAddSuccess = true;
      // now 'this' is referencing the Vue object and not the 'setTimeout' scope
      setTimeout(() => this.basketAddSuccess = false, 5000);
    },
    getInfo: function() {
        if (this.currentReport.includes('score') ) {
            for (const i of this.data.scores.scores_entry) {
                const roundNo = this.data.round;
                const proAmaInd = (i.pro_ind);
                const sponsored = (i.sponsored == 'Y');
                const entrySponsored = (i.entry_sponsored == 'Y');
                const startTee = (i['tee_R' + roundNo]);
                if (proAmaInd == 'Am') {
                    this.hasAmaPlayers = true;
                }
                if (sponsored) {
                    this.hasSponsPlayer = true;
                }
                if (entrySponsored) {
                    this.hasEntSponsPlayer = true;
                }
                if (startTee != 1) {
                    this.hasNonFirstTee = true;
                }
            }            
        } else if (this.currentReport.includes('result') ) {
            for (const i of this.data.result.result_entry) {
                const roundNo = this.data.round;
                const proAmaInd = (i.pro_ind);
                const sponsored = (i.sponsored == 'Y');
                const entrySponsored = (i.entry_sponsored == 'Y');
                const startTee = (i['tee_R' + roundNo]);
                if (proAmaInd == 'Am') {
                    this.hasAmaPlayers = true;
                }
                if (sponsored) {
                    this.hasSponsPlayer = true;
                }
                if (entrySponsored) {
                    this.hasEntSponsPlayer = true;
                }
                if (startTee != 1) {
                    this.hasNonFirstTee = true;
                }
            }            
        } else if (this.currentReport.includes('entr') ) {
            for (const i of this.data.entries.entries_entry) {
                const roundNo = this.data.round;
                const proAmaInd = (i.pro_ind);
                const sponsored = (i.sponsored == 'Y');
                const entrySponsored = (i.entry_sponsored == 'Y');
                const startTee = (i['tee_R' + roundNo]);
                if (proAmaInd == 'Am') {
                    this.hasAmaPlayers = true;
                }
                if (sponsored) {
                    this.hasSponsPlayer = true;
                }
                if (entrySponsored) {
                    this.hasEntSponsPlayer = true;
                }
                if (startTee != 1) {
                    this.hasNonFirstTee = true;
                }
            }            
        } else if (this.currentReport.includes('draw') ) {
            for (const i of this.data.draw.draw_entry) {
                const roundNo = this.data.round;
                const proAmaInd = (i.pro_ind);
                const sponsored = (i.sponsored == 'Y');
                const entrySponsored = (i.entry_sponsored == 'Y');
                const startTee = (i['tee_R' + roundNo]);
                if (proAmaInd == 'Am') {
                    this.hasAmaPlayers = true;
                }
                if (sponsored) {
                    this.hasSponsPlayer = true;
                }
                if (entrySponsored) {
                    this.hasEntSponsPlayer = true;
                }
                if (startTee != 1) {
                    this.hasNonFirstTee = true;
                }
            }            
        } else {
            console.log('no score')
        }

    },
    updateStuffMulti: function() {
      axios
        .get(this.reportTitleUP)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE +
              this.tour +
              '/' +
              this.id +
              "/" +
              this.id +
              "-" +
              this.code +
              "-tmticx.json?randomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.tmparams = response.data;
        });
    },
    swapTour:function(code) {
      this.course = code;
      // console.log("this.course -- in swap")
      // console.log(this.course)
      this.getSecondTournTicx(code);
      this.updateStuffMulti();
    },
    getSecondTournTicx(code) {
      axios
        .get(this.reportTitle)
        .then(response => {
          this.data = response.data;
          return axios.get(
            process.env.VUE_APP_TIC_BASE + 
              this.tour +
              '/' +
              this.id +
              "/" +
              this.id +
              "-" +
              code +
              "-tmticx.json?mattrandomadd=" +
              new Date().getTime()
          );
        })
        .then(response => {
          this.second_tourn_tixc = response.data;
          // console.log( "this.second_tourn_tixc")
          // console.log( this.second_tourn_tixc)
          this.winnerType = response.data.winner_result;
          if (typeof this.second_tourn_tixc.reports != "undefined") {
            console.log('Line 663')
            this.second_tourn_tixc.reports.reports_entry.forEach(element => {
              if (element.report_url.indexOf("tmscore") !== -1) {
                this.currentReport = element.report_url;
                // console.log("this.report")
                // console.log(this.report)
                this.updateStuffMulti();
                // console.log('Line 668')
              }
              if (element.report_url.indexOf("tmresult") !== -1) {
                this.currentReport = element.report_url;
                // console.log('Line 672')
                this.updateStuffMulti();
              }
            });
          }
        });
    },
    isMobile() {
      if (screen.width <= 768) {
        return true;
      } else {
        return false;
      }
    },

    changeReport: function(event) {
      var report = event.target.getAttribute("title");
      var title = event.target.getAttribute("value");
      this.title = title;
      return (
        (this.currentReport = report),
        axios
          .get(this.reportTitle)
          .then(({ data }) => {
            this.data = data;
            this.getInfo();
            // console.log("this.data change")
            // console.log(this.data)
          })
      );
    },
    updateStuff: function() {
      apiCall
        .report(this.reportTitleUP)
        .then(({ data }) => {
          this.data = data;
          // console.log("this.data update")
          // console.log(this.data)
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
          throw error;
        });
    },
    upDown() {
      this.updown = !this.updown;
    },
    // reportListText: function() {
    //   this.reports.forEach((value) => {
    //     if (value.report_title.includes('Draw')) {
    //       this.listOfreportNames = 'Draw'
    //       console.log("this.listOfreportNames")
    //       console.log(this.listOfreportNames)
    //     }
    //   });
    // },
  },
  created() {
    setInterval(this.updateStuff, 120000);
  },
  mounted() {
    // this.reportListText();
    apiCall
      .report(this.currentReport)
      .then(({ data }) => {
        this.data = data;
        console.log("this.data")
        console.log(this.data)
        this.getInfo();
        // console.log("this.data mounted")
        // console.log(this.data)
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        throw error;
      });
  },
};
</script>

<style scoped>
button.playerInfoButtonTrue {
    color: #ffffff;
    background: green!important;
    border: 0px;
    text-align: left;
    width: 200px;
    height: 44px;
    float: right;
    position: relative;
    top: 70px;
    left: 20px;
}
button.playerInfoButtonTrue:after {
  content: "";
  width: 30px;
  height: 30px;
  background:  url("https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/icons8-refresh-30.png") no-repeat;
  top: 7px;
  right: 5px;
  position: absolute;
  display: inline-block;
}
button.playerInfoButtonTrue:before {
  content: "Scores Updated"
}
.iconsSize {
    width: 20px;
    margin-left: 15px;
    margin-top: -2px;
}
button.playerInfoButton {
    color: #ffffff;
    background: rgb(51, 203, 169) !important;
    border: 0px;
    text-align: left;
    width: 200px;
    height: 44px;
    float: right;
    position: relative;
    top: 69px;
    left: 20px;
}
button.playerInfoButton:hover {
    color: #ffffff;
    background: rgb(0, 60, 82) !important;
    border: 0px;
    text-align: left;
    width: 200px;
    height: 44px;
    float: right;
    position: relative;
    top: 70px;
    left: 20px;
}
button.playerInfoButton:after {
  content: "";
  width: 30px;
  height: 30px;
  background:  url("https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/icons8-refresh-30.png") no-repeat;
  top: 7px;
  right: 5px;
  position: absolute;
  display: inline-block;
}
button.playerInfoButton:before {
  content: "Live Scoring Active"
}

button.playerInfoButton:hover:before  {
  content: "Refresh Scores"
}
button.playerInfoButtonMob {
  color: #ffffff;
  background: rgb(51, 203, 169) !important;
  border: 0px;
  text-align: left;
  width: 100%;
  height: 44px;
  float: none;
  position: relative;
  top: 0;
  left: 0;
}
button.playerInfoButtonMob:after {
  content: "";
  width: 30px;
  height: 30px;
  background:  url("https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/icons8-refresh-30.png") no-repeat;
  top: 7px;
  right: 5px;
  position: absolute;
  display: inline-block;
}
button.playerInfoButtonMob:before {
  content: "Live Scoring Active"
}
.informationImg{
  width: 20px;
  /* background: #003c52; */
  float: right;
  margin-bottom: 50px;
  position: relative;
  top: 10px;
}
.loader {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #00433e;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.dropDownArea {
  margin-top: 40px;
}
.media.nomarginleft {
  /* margin-left: 17em; */
}
span.namefemale {
  font-size: 10pt;
  font-weight: bold;
  color: #000;
}
.female {
  color: #e33;
}
.genderBall {
  font-size: 30px !important;
  line-height: 0 !important;
}
.femaleBall {
  position: relative;
  top: 4px;
}
.maleBall {
  position: relative;
  top: 4px;
  color: rgb(0, 60, 82);
}
.ad {
  margin-bottom: 30px;
  margin-top: 30px;
}
.titliestText {
  position: relative;
  top: 8px;
  left: 10px;
}
.titleistBll {
  display: -webkit-inline-box;
  padding-top: 20px;
}
.imob {
  border: none;
  /* width: 240px; */
  height: 80px;
  /* float: right; */
  position: relative;
  top: 60px;
}
.tRowTopMainnonMobile {
  background-color: transparent!important;
}
.tRowTopMain {
  background-color: rgba(0, 0, 0, 0.04);
}
.col-lg-6.col-12.colWidth {
  flex: 0 0 33.333333%;
  max-width: 33.333333%;
}
::v-deep .nav-tabs .nav-link {
  margin-bottom: -1px;
  border: 0px solid transparent;
  border-top-left-radius: 0rem;
  border-top-right-radius: 0rem;
  color: #000 !important;
}
::v-deep .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link {
  color: #495057;
  background-color: #003c52;
  border: 0px !important;
  color: #fff !important;
  border-top-left-radius: 0rem!important;
  border-top-right-radius: 0rem!important;
}
.media {
  margin-left: 13em;
}
.mediaNone {
  margin-left: 0em;
}
::v-deep .dropdown-item {
  color: #003C52!important;
}
.reportInfo {
  font-weight: 600;
  font-size: 1.5rem;
}
.coursesP {
  margin-bottom: 0px;
}
::v-deep .NopadLeft {
  padding-left: 15px!important;
}
::v-deep .NoPad {
  padding: 0px;
}
::v-deep button.btn.tabBtn.btn-secondary {
  height: 38px;
  padding-top: 7px;
  padding-bottom: 10px;
}
::v-deep button.btn.tabBtn.btn-secondary.active {
  height: 38px;
  padding-top: 7px;
  padding-bottom: 10px;
}
::v-deep button#__BVID__32__BV_toggle_ {
  /* line-height: 35px; */
    line-height: 0.6;
}
.BallUsage {
  font-size: 10pt;
  font-weight: bold;
  margin-bottom: 0;
}
.rookieYear {
  font-size: 10pt;
  font-weight: bold;
  margin-top: 8px;
}
#reports {
  /* background-color: #f9f9f9; */
}
.topPad {
  padding-top: 0px;
}
.titleMainTour {
  color: #000;
  margin: 0;
  font-size: 10pt;
  font-weight: 700;
  padding-left: 10px;
  line-height: 2;
}
li {
  list-style-type: none;
}
.menuLink {
  text-align: right;
}
.menuLink > a {
  padding: 4px 0 0 3em;
  text-transform: capitalize;
  font-size: 10pt;
  font-weight: 500;
}
.tRow {
  border-bottom: 1px solid #000;
  padding: 10px 0;
}
.multi {
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 600;
}
.multiList {
  /* padding: 0 10px; */
}
.multiName {
  color: #000000 !important;
  position: relative !important;
  top: -14px !important;
  /* padding-left: 17px; */
  padding-right: 10px;
  font-size: 14px !important;
}
.multiList > span {

}
.tournDates {
  text-align: left;
  color: #003c52;
  margin-top: 8px;
  margin-bottom: 0;
  font-weight: 600;
  font-size: 14px;
  font-weight: 600;
  color: #003c52;
}
.tournHead {
  text-align: left;
  margin-top: 8px;
  margin-bottom: 0;
  font-weight: 600;
  font-family: 'Gantari', sans-serif !important;
  color: #000;
  font-size: 45px;
  padding-bottom: 20px;
}
.tournHeadLogo {
  max-width: 323px;
  display: block;
  padding-bottom: 10px;
  width: 150px;
  /* float: right;  */
}
.tournHeadLogoMob {
  max-width: 323px;
  display: none;
  padding-bottom: 10px;
  width: 200px;
}
.ShowMobile.col-lg-12.col-12 {
  padding-top: 30px;
  padding-bottom: 25px;
}
.tabRow {
  padding: 0;
  padding-top: 20px;
  width: 400px;
}
.tabBtn {
  width: 100%;
  color: #0c4c39;
  background-color: #e6e6e6;
  border: none;
  /* padding: 10px 0; */
  text-align: center;
}
.active {
  color: white !important;
  /* background-color: #00b588 !important; */
}
::v-deep tr:nth-child(even) {
  background-color: rgba(0, 0, 0, 0.04);
}
::v-deep .drop {
  padding-left: 10px;
  padding-bottom: 2%;
}
.sponsor {
  margin-top: -10%;
  width: 20%;
  padding-left: 10%;
}

.nav-link {
  color: black !important;
  width: 100%;
  font-size: 18pt;
}

::v-deep .mt-3 {
  margin-top: 0 !important;
}
.B {
  color: #333333;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}
.Y {
  color: #d8db22;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}
.C {
  color: #1E90FF;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}
.R {
  color: #BB0000;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}
.G {
  color: #3c9933;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}
.O {
  color: #e07020;
    font-size: 43px !important;
  line-height: 1.2;
  vertical-align: bottom !important;
}

.noData {
  text-align: center;
  padding: 70px;
  background-color: #00433e;
  color: white;
}
::v-deep button {
  color: black;
  background-color: transparent;
  border: 1px solid black;
  border-radius: 0;
  width: 250px;
  text-align: left;
  line-height: 26px;
  height: 38px;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
::v-deep button::after {
  float: right;
  margin-top: 0px;
  position: relative;
  /* top: 3px; */
  top: 12px;
}
::v-deep button:hover {
  color: #003C52;
  background-color: white;
}
.card-header-pills {
  margin-right: -0.625rem;
  margin-left: 0rem;
  width: 100%;
  display: block;
}
.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 1.75rem 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #000;
  vertical-align: middle;
  background: #fff url(data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='5' viewBox='0 0 4 5'%3e%3cpath fill='%23343a40' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e) right 0.75rem center / 8px 10px no-repeat;
  border: 1px solid #ced4da;
  /* border-radius: 0.25rem; */
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}
@media only screen and (min-width: 769px) {
  .ShowMobile {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .hidebelow1200 {
    display: none;
  }
  .tournHeadLogo {
    max-width: 323px;
    display: block;
    padding-bottom: 10px;
    width: 150px;
    float: left;
    margin-top: 30px;
  }
  .imob {
    border: none;
    /* width: 240px; */
    height: 80px;
    float: left;
    top: 0;
  }
}
@media only screen and (min-width: 1024px) {
  .showMob {
    display: none;
  }
}
@media only screen and (max-width: 1023px) {
  .showDesk {
    display: none;
  }
  ::v-deep li.nav-item.hideHBH {
    display: none;
  }
  ::v-deep li.nav-item.aus {
    /* display: none; */
  }
  ::v-deep li.nav-item.hideLeadertab {
    display: none;
  }
}
@media only screen and (max-width: 768px) {
  button.playerInfoButtonTrue {
      color: #ffffff;
      background: green!important;
      border: 0px;
      text-align: left;
      width: 100%;
      height: 44px;
      float: right;
      position: relative;
      top: 0px;
      left: 0px;
  }
  button.playerInfoButtonTrue:after {
    content: "";
    width: 30px;
    height: 30px;
    background:  url("https://wp-ocssport.ocs-sport.com/wp-content/uploads/2025/12/icons8-refresh-30.png") no-repeat;
    top: 7px;
    right: 5px;
    position: absolute;
    display: inline-block;
  }
  button.playerInfoButtonTrue:before {
    content: "Scores Updated"
  }
  .informationImg{
    width: 20px;
    /* background: #003c52; */
    float: right;
    margin-bottom: 15px;
    position: relative;
    top: 10px;
  }
  .iconsSize {
    width: 20px;
    margin-left: 15px;
    margin-top: 3px;
    float: right;
  }
  button.playerInfoButton {
    color: #ffffff;
    background: rgb(51, 203, 169) !important;
    border: 0px;
    text-align: left;
    width: 100%;
    height: 44px;
    float: none;
    position: relative;
    top: 0;
    left: 0;
  }
  button.playerInfoButton:hover {
    color: #ffffff;
    background: rgb(0, 60, 82) !important;
    border: 0px;
    text-align: left;
    width: 200px;
    height: 44px;
    float: right;
    position: relative;
    top: 0;
    left: 0;
  }
  .imob {
    border: none;
    width: 100%;
    height: 80px;
    float: left;
    top: 0;
  }
  .paddBottom {
    padding-bottom: 30px;
  }
  ::v-deep .dropdown.b-dropdown.btn-group {
    width: 102.5%;
    margin-bottom: 17px;
  }
  .card-header-pills {
    margin-right: -0.625rem;
    margin-left: -0.625rem;
    width: 100%;
    display: block;
  }
  ::v-deep button {
    width: 100%!important;
  }
  .tournDates {
    text-align: left;
    color: #000;
    margin-top: 8px;
    margin-bottom: 0;
    font-weight: 100;
    font-size: 14px;
    font-weight: 600;
  }
  .tournHeadLogo {
    display: none;
  }
  .media {
    margin-left: 0;
  }
  .hideMobile {
    display: none;
  }
  .topPad {
    padding-top: 0px;
  }
  .mobHide {
    display: none;
  }
  .tournHead {
    text-align: left;
    margin-top: 8px;
    margin-bottom: 0;
    font-weight: 600;
    font-family: 'Gantari', sans-serif !important;
    color: #000;
    font-size: 33px;
  }
}
@media only screen and (max-width: 480px) {
  .sponsor {
    margin-top: 2%;
    width: 35%;
    padding-left: 4%;
  }
  ::v-deep .dropdown.b-dropdown.btn-group {
    width: 100%!important;
    margin-bottom: 17px;
    margin-top: 17px;
  }
  .card-header-pills {
    margin-right: 0!important;
    margin-left: 0!important;
    width: 100%;
    display: block;
  }
}
</style>